<app-spinner [loading]="isCreating"></app-spinner>
<app-crypto-token-form [slots]="slots()" [areSlotsLoading]="areSlotsLoading()"
(cryptotokenRequest)="onRequest($event)"
(cancelCreation)="onCancel()"
(needSlots)="onNeedSlots()"></app-crypto-token-form>
